import React, { useState, useRef, useEffect, useCallback } from 'react';
import { getLessonsGroupedBySection } from './utils/lessonService';
import { ChevronDown, ChevronUp, PlayCircle } from 'lucide-react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import '@videojs/themes/dist/sea/index.css';
// HLS desteği için
import '@videojs/http-streaming';
import 'videojs-hls-quality-selector';
import './App.css';
import LoadingCourse from './components/LoadingCourse';
import LecturePage from './LecturePage';

const App = ({ userData }) => {
  const [courseData, setCourseData] = useState(null);

  // Ödeme başarılı olduğunda kupon kodunu temizle (backend'den redirect geldiğinde)
  useEffect(() => {
    // URL'de paymentId varsa ödeme başarılı demektir
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('paymentId')) {
      localStorage.removeItem('referral_coupon_code');
      console.log('✅ Ödeme başarılı (backend redirect) - Kupon kodu temizlendi');
    }
  }, []);

  // Firestore'dan dersleri test amaçlı çek ve logla
  useEffect(() => {
    const fetchLessons = async () => {
      try {
        const sections = await getLessonsGroupedBySection();
        const dbCourseData = {
          title: "Yaşasın Hamileyim",
          sections: sections
        }
        setCourseData(dbCourseData);
        //console.log('[Lessons] Firestore grouped data:', grouped);
      } catch (error) {
        //console.error('[Lessons] Firestore fetch error:', error);
      }
    };
    fetchLessons();
  }, []);

  return courseData ? <LecturePage courseData={courseData} userData={userData} /> : <LoadingCourse />;
};

export default App;